import { isTenantAdministrator } from './administratorAccess';
export const canReadInvoices = user => isTenantAdministrator(user) || Boolean(user?.roles?.some(r => r.key === 'VERWALTER'));
export const canWriteInvoices = canReadInvoices;
